import { resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_chip = _resolveComponent("v-chip");
    return (_openBlock(), _createBlock(_component_v_chip, {
        label: "",
        small: "",
        pill: "",
        class: _normalizeClass(["brg-chip chip caption-normal-text px-1 py-0", `${_ctx.chipColor} ${_ctx.cssClassLarge}`]),
        color: _ctx.color,
        "text-color": _ctx.textColor,
        textContent: _toDisplayString(_ctx.text)
    }, null, 8 /* PROPS */, ["class", "color", "text-color", "textContent"]));
}
